import type React from "react"
import { TableCell } from "@mui/material"
import { StatusCellPopover } from "./TableCellWithPopover"

interface TableCellWithPopoverProps {
  status: string
  icon: React.ReactNode
  title?: string
  cellWidth?: string
  onOpen?: () => Promise<
    {
      label: string
      value: string
    }[]
  >,
    errorMessage?: string
}

export function TableCellWithPopover({ status, icon, title, cellWidth = "70%", onOpen, errorMessage }: TableCellWithPopoverProps) {
  return (
    <TableCell
      sx={{
        width: cellWidth,
        fontFamily: "Montserrat",
        color: "#10383D",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "24px",
        textAlign: "center",
      }}
    >
      <StatusCellPopover status={status} icon={icon} title={title} onOpen={onOpen} errorMessage={errorMessage} />
    </TableCell>
  )
}